// src/lib/affiliateApiClient.js
//
// A separate axios instance for the affiliate-facing app (login, dashboard).
// Deliberately NOT the shared apiClient.js: that client auto-attaches the
// Supabase session token on every request, which affiliates never have (see
// affiliateAuth.js for why affiliate auth is isolated from Supabase Auth).
// This one attaches the affiliate's own Bearer session token from localStorage.

import axios from 'axios';

const SESSION_KEY = 'affiliate_session_token';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const affiliateApiClient = axios.create({
  baseURL: `${API_BASE}/affiliates/auth`,
});

export function getAffiliateSession() {
  return localStorage.getItem(SESSION_KEY);
}

export function setAffiliateSession(token) {
  localStorage.setItem(SESSION_KEY, token);
}

export function clearAffiliateSession() {
  localStorage.removeItem(SESSION_KEY);
}

affiliateApiClient.interceptors.request.use((config) => {
  const token = getAffiliateSession();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

affiliateApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAffiliateSession();
    }
    return Promise.reject(error);
  }
);

export default affiliateApiClient;
